import React from 'react';
import { Empty } from 'antd';

const EmptyDescription = () => {
  const description = (
    <>
      <span style={{ display: 'block' }}>
        Недостаточно данных для формирования шахматки
      </span>
      <span style={{ display: 'block' }}>Заполните обязательные поля</span>
    </>
  );

  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />
  );
};

export default EmptyDescription;
